var map = {
	"./1.svg": "1d0a",
	"./2.svg": "48a7",
	"./3.svg": "a0ec",
	"./4.svg": "3920",
	"./5.svg": "01ac",
	"./6.svg": "60a2",
	"./7.svg": "bddc",
	"./8.svg": "970a",
	"./9.svg": "6ae9",
	"./rightbox.svg": "0018"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edce";